/***
 Created by IntelliJ IDEA.
 User: xiexy
 Date: 2019/12/3
 ***/

import Vue from "vue";

Vue.filter("nameFilter", (val = "") => {
  return val.substring(0, 1) + "*" + val.substring(2);
});

Vue.filter("certNoFilter", (val = "") => {
  return val.substring(0, 4) + "********" + val.substring(14);
});

Vue.filter("mobileFilter", (val = "") => {
  return val.substring(0, 3) + "****" + val.substring(7);
});

Vue.filter("amtFilter", (val = 0) => {
  return (val / 100).toFixed(2);
});

Vue.filter("bankFilter", (val = 0) => {
  return "**** " + val.substr(-4);
});

Vue.filter("citizenFilter", (val = 0) => {
  return val.substr(0, 4) + "**** " + val.substr(-4);
});

/// 过万之后显示w，保留一位小数
Vue.filter("numWFilter", (val = 0) => {
  if (val >= 10000) {
    return (val / 10000).toFixed(1) + "w";
  } else {
    return val;
  }
});



// WEBPACK FOOTER //
// ./src/filters/index.js